import { render, staticRenderFns } from "./GuardarCambiosButton.vue?vue&type=template&id=5de45e53&"
import script from "./GuardarCambiosButton.vue?vue&type=script&lang=ts&"
export * from "./GuardarCambiosButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5de45e53', component.options)
    } else {
      api.reload('5de45e53', component.options)
    }
    module.hot.accept("./GuardarCambiosButton.vue?vue&type=template&id=5de45e53&", function () {
      api.rerender('5de45e53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Modal/GuardarCambiosButton.vue"
export default component.exports